import React from 'react';
import BreadCrumbNav from './BreadCrumbNav';
import Footer from './Footer';
import MainHeader from './MainHeader';
import MobileMenu from './MobileMenu';
import ScrollToTopButton from './ScrollToTopButton';
import SearchPopup from './SearchPopup';
import TestimonialList from './TestimonialList';

const TestimonialPage = () => {

  return (
    <div className="boxed_wrapper">
        <SearchPopup />
        <MainHeader />
        <MobileMenu />
        <BreadCrumbNav title="Testimonials" />

        <TestimonialList />

        <Footer />
        <ScrollToTopButton />
    </div>
    );
  }
  
  export default TestimonialPage;